<p>{{ description | async }}</p>
<mat-progress-bar
  class="example-margin"
  [color]="color"
  [mode]="mode"
  [value]="valueSubject | async"
>
</mat-progress-bar>
